	export enum MedicalReportBinauralDiscriminationEnum {
		Same = 1,
		Improve = 2
	}
